export default {"src":"/_next/static/media/pdf.c5c0cd60.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};